import { Injectable } from '@angular/core';
import { Game } from './../model/Game';

@Injectable({
  providedIn: 'root'
})
export class GameService {

  private _doors: Map<number, Game> = new Map<number, Game>();
  private _key: number = 0;
  constructor() {
    let v = localStorage.getItem("mydoors");
    if (!v) v ='[[1,{"id":1,"timer":{"id":null,"timer":{"id":2,"time":600000,"image":"assets/images/timer2.png","name":"FÁCIL","description":"Un poco mejor que el básico"}},"lock":{"id":null,"lock":{"id":1,"digits":4,"tries":7,"durability":10000,"name":"REFORZADO","description":"5 dígitos son mejores que 4. Sin duda.","image":"assets/images/lock.png","codification":{"type":"numbers","image":null,"size":10}},"durability":10000,"_code":{"code":[]}}}],[2,{"id":2,"timer":{"id":null,"timer":{"id":2,"time":600000,"image":"assets/images/timer2.png","name":"FÁCIL","description":"Un poco mejor que el básico"}},"lock":{"id":null,"lock":{"id":1,"digits":4,"tries":7,"durability":10000,"name":"REFORZADO","description":"5 dígitos son mejores que 4. Sin duda.","image":"assets/images/lock.png","codification":{"type":"numbers","image":null,"size":10}},"durability":10000,"_code":{"code":[]}}}]]';
    if (v) {
      this._doors = new Map();
      JSON.parse(v).forEach(e => {
        this._doors.set(e[0], Game.fromData(e[1]));
      })

      this._doors.forEach(e => {
        if (e.id > this._key) {
          this._key = e.id;
        }
      });
    } else {
      this._doors = new Map<number, Game>();
      this._key = 0;
    }

  }
  public getMyDoors(): Promise<Game[]> {
    return Promise.resolve(Array.from(this._doors.values()));
  }

  public saveDoor(game: Game): Promise<Game> {
    if (!game.id) {
      game.id = ++this._key;
    }
    this._doors.set(game.id, game);
    localStorage.setItem("mydoors", JSON.stringify([...this._doors]));
    return Promise.resolve(game);
  }

  public getDoor(id: number) {
    return Promise.resolve(this._doors.get(id));
  }
}
